import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDownsize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDownsize"><Path d="M3.5 9.5H9.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 9.5H14.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 20.5V14.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5H9.5V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDownsize;
